import { useState } from "react";
//Components
import FilterDrawer from "../../../../../components/FilterDrawer/FilterDrawer";
import FilterChipsWrap from "../../../../../components/FilterDrawer/FilterChips/FilterChipsWrap";
import FilterLabel from "../../../../../components/FilterDrawer/FilterLabel/FilterLabel";
import FilterChips from "../../../../../components/FilterDrawer/FilterChips/FilterChips";
import FilterCheckBoxWrap from "../../../../../components/FilterDrawer/FilterCheckBoxWrap";
import { FormGroup } from "@mui/material";
import FilterCheckbox from "../../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import FilterTypeWrap from "../../../../../components/FilterDrawer/FilterTypeWrap";

const PurchaseFilter = (props: any) => {
  const {
    handleFilterChange,
    selectedStatuses,
    handleResetClick,
    handleApplyFilters,
    appliedFilter,
    cancelClick,
    clearStatus,
  } = props;

  const handleFilterClose = () => console.log("filterClose");

  const filterItems = [
    { label: "Completed" },
    { label: "Pending" },
    { label: "Failed" },
  ];

  return (
    <FilterDrawer
      handleFilterApply={handleApplyFilters}
      handleResetClick={handleResetClick}
      activeFilter={appliedFilter}
      cancelClick={cancelClick}
      closeSetFilter={handleFilterClose}
    >
      <div
        style={{
          padding: "22px 32px ",
          overflowY: "auto",
          maxHeight: "calc(100% - 110px)",
        }}
      >
        <FilterChipsWrap>
          {selectedStatuses.length > 0 &&
            selectedStatuses.map((item: any, index: number) => (
              <FilterChips
                key={`${item}-${index}`}
                keyVal={`${item}-${index}`}
                chipName={item}
                clearValue={item}
                closeFunction={clearStatus}
              />
            ))}
        </FilterChipsWrap>
        <FilterTypeWrap>
          <FilterLabel labelValue="Status" />
          <FilterCheckBoxWrap>
            <FormGroup>
              <div
                style={
                  {
                    /* paddingLeft: '20px' */
                  }
                }
              >
                {filterItems.map((item) => (
                  <FilterCheckbox
                    key={item.label}
                    checked={selectedStatuses.includes(
                      item.label.toLowerCase()
                    )}
                    keyVal={item.label}
                    checkboxFunction={() => {
                      handleFilterChange(item.label);
                    }}
                    label={item.label.toLowerCase().replace(/_/g, " ")}
                  />
                ))}
              </div>
            </FormGroup>
          </FilterCheckBoxWrap>
        </FilterTypeWrap>
      </div>
    </FilterDrawer>
  );
};
export default PurchaseFilter;
